import { HTTP_TYPES } from '@/lib/enums'
import api from '@/api/api'

const response = {
  async postSetupDatashakeScheduleForProfile(profile_uuid: string): Promise<any> {
    return await api(
      HTTP_TYPES.POST,
      `${import.meta.env.VITE_DEPOT_API_REVIEWS}/datashake/schedules/${profile_uuid}`
    )
  }
}

export default response
